import { MouseEvent, useCallback } from 'react';

import { ApiNotification } from 'api/notification/types/ApiNotification';
import { NotificationListItem } from 'components/NotificationList/Item/NotificationListItem';
import {
  markNotificationsAsDismissed,
  markNotificationsAsRead,
} from 'modules/main/store/ducks/userNotifications.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { getMappedNotificationIds } from 'utils/userNotifications';

type Props = {
  notification: ApiNotification | MappedNotification;
  dismissible: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export function UserNotificationListItem({
  notification,
  dismissible,
  onClick,
}: Props) {
  const dispatch = useMainDispatch();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      dispatch(markNotificationsAsRead(getMappedNotificationIds(notification)));
      onClick?.(event);
    },
    [dispatch, notification, onClick],
  );

  const handleDismiss = useCallback(
    () =>
      dispatch(
        markNotificationsAsDismissed(getMappedNotificationIds(notification)),
      ),
    [dispatch, notification],
  );

  return (
    <NotificationListItem
      notification={notification}
      onClick={handleClick}
      onDismiss={dismissible ? handleDismiss : undefined}
      qaId="notification"
    />
  );
}
